import type { CurrentUserFetchResponse } from '@api/users/api.users.types';

export const carrotQuestAuth = (
  user?: CurrentUserFetchResponse,
  userHash?: string,
) => {
  const canAuthenticate = user?.id && userHash;
  if (canAuthenticate && typeof carrotquest !== 'undefined') {
    carrotquest.auth(user.id, userHash);
  }
};
